import { MutationTree } from 'vuex';
import { cloneDeep } from 'lodash';
import { ActionStatus } from '@/application/types';
import { Authentication, AuthenticationState } from '../types';
import { authenticationStateDefaults } from './defaults';

export const authenticationMutations: MutationTree<AuthenticationState> = {

  clear(state) {
    state.isAuthenticated = cloneDeep(authenticationStateDefaults.isAuthenticated);
    state.user = cloneDeep(authenticationStateDefaults.user);
    state.loginStatus = cloneDeep(authenticationStateDefaults.loginStatus);
    state.logoutStatus = cloneDeep(authenticationStateDefaults.logoutStatus);
    state.fetchAuthenticatedUserStatus = cloneDeep(authenticationStateDefaults.fetchAuthenticatedUserStatus);
  },

  // Login process

  loginStarted(state) {
    state.loginStatus = ActionStatus.InProgress;
  },

  loginSucceeded(state, authentication: Authentication) {
    state.loginStatus = ActionStatus.Successful;
    state.isAuthenticated = true;
    state.user = authentication.user;
  },

  loginFailed(state) {
    state.loginStatus = ActionStatus.Failed;
    state.isAuthenticated = false;
    state.user = cloneDeep(authenticationStateDefaults.user);
  },

  // Logout process

  logoutStarted(state) {
    state.logoutStatus = ActionStatus.InProgress;
  },

  logoutSucceeded(state) {
    state.logoutStatus = ActionStatus.Successful;
    state.isAuthenticated = false;
    state.user = cloneDeep(authenticationStateDefaults.user);
  },

  logoutFailed(state) {
    state.logoutStatus = ActionStatus.Failed;
  },

  // Fetch authenticated user process

  fetchAuthenticatedUserStarted(state) {
    state.fetchAuthenticatedUserStatus = ActionStatus.InProgress;
  },

  fetchAuthenticatedUserSucceeded(state, authentication: Authentication) {
    state.fetchAuthenticatedUserStatus = ActionStatus.Successful;
    state.isAuthenticated = true;
    state.user = authentication.user;
  },

  fetchAuthenticatedUserFailed(state) {
    state.fetchAuthenticatedUserStatus = ActionStatus.Failed;
  },

};
